import { mapActions, mapGetters } from 'vuex';
import { paymentModalNames, paymentSources } from 'client/GrowthEngineering/utilities/GrowthConstants';
import EventHelper from 'client/GrowthEngineering/EventHelper';
import EventManager from 'client/GrowthEngineering/EventManager';
import ModalEventBus from 'components/Modal/ModalEventBus';
import Util from 'client/util/Util';

const checkoutModel = 'CheckoutModel';
const settingsModule = 'SettingsModule';

export default {
  computed: {
    ...mapGetters(settingsModule, {
      isProvider: 'isProvider',
      hasBilling: 'hasBilling',
    }),

    ...mapGetters(checkoutModel, {
      subscription: 'item',
    }),
  },

  data() {
    return {
      calendlyLink: 'https://calendly.com/get-started-with-jumpcloud/20-min',
    };
  },

  methods: {
    ...mapActions(checkoutModel, {
      resetSubscription: 'resetItem',
      updateItem: 'updateItem',
    }),

    handleBuyNowButtonClicked(modal, subscription) {
      if (subscription) {
        this.updateItem(subscription);
      }

      EventManager.triggerPaymentModalViewed({
        modal: paymentModalNames.paymentSetup,
        source: paymentSources.buyNowButton,
      });

      const buyNowPayload = { modal };
      if (subscription) buyNowPayload.subscription = subscription.displayName;
      this.handleNextStep();
    },

    handleContactSalesButtonClicked(modal) {
      EventHelper.triggerContactSalesButtonClicked({ modal });
    },

    handleEmailSalesLinkClicked(modal) {
      EventHelper.triggerEmailSalesLinkClicked({ modal });
    },

    handleCalendlyLinkClicked(modal, packageName) {
      if (!this.isProvider) {
        EventHelper.triggerCalendlyLinkClicked({ modal, packageName });
      } else {
        EventHelper.triggerProviderCalendlyLinkClicked({ modal, packageName });
      }
    },

    handleClose() {
      this.resetSubscription();
      ModalEventBus.close();
    },

    handleCloseAndRedirect() {
      this.handleClose();
      Util.redirect('#/users/add');
    },

    handleCloseAndTrackEvent(modal) {
      this.handleClose();
      if (!this.isProvider) {
        EventManager.triggerPaymentModalDismissed({ modal });
      } else {
        EventHelper.triggerProviderPaymentModalDismissed({ modal });
      }
    },

    handlePaymentLinkClicked(link, modal) {
      if (!this.isProvider) {
        EventHelper.triggerPaymentLinkClicked({ link, modal });
      } else {
        EventHelper.triggerProviderPaymentLinkClicked({ link, modal });
      }
    },
  },

  props: {
    handleContactSales: {
      type: Function,
      default: () => { },
    },

    handleLastStep: {
      type: Function,
      default: () => { },
    },

    handleNextStep: {
      type: Function,
      default: () => {},
    },
  },
};
